<script>
	import request from './request.vue';
	import Category from './category.model.vue';

	import { format } from "date-fns";

	const courseSchema = [
		{
			name: "id",
			displayName: "Código",
			kind: "text",
			validation: "",
			placeholder: "Digite o código da empresa",
			defaultSort: true,
			readOnly: true,
			search: {
				show: false,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "name",
			displayName: "Nome",
			kind: "text",
			validation: "required|max:80",
			placeholder: "Digite o nome do curso",
			notInFilters: false,
			defaultSort: true,
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "creationDate",
			displayName: "Data do cadastro",
			kind: "text",
			validation: "",
			placeholder: "",
			readOnly: true,
			notInFilters: true,
			formatter: value => format(value, "DD/MM/YYYY HH:mm"),
			creationHidden: true,
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "description",
			displayName: "Descrição",
			kind: "long-text",
			validation: "required",
			placeholder: "",
		},
		{
			name: "categoryId",
			displayName: "Categoria",
			validation: "required",
			kind: "select",
			placeholder: "",
			options: [],
			search: {
				show: false,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "iconUrl",
			displayName: "Ícone",
			kind: "picture-url",
			validation: "",
			placeholder: "",
			search: {
				show: false,
			},
			upload: async function (id, file) {
				const formData = new FormData();
				formData.append("file", file, file.name);
				let response = await request.sendFormData("course", `uploadIcon/${id}`, formData);
				return response.data;
			},
		},
	];

	Category.getAll()
		.then((categories) => {
			courseSchema.find(field => field.name === "categoryId").options = categories.map(category => ({
				name: category.name,
				value: category.id,
			}));
		})
		.catch((err) => console.log(err));

	export default {
		create: async function (entity) {
			const response = await request.send("course", "create", entity, true);
			return response.data;
		},
		getInfo: async function (id) {
			const response = await request.send("course", "read", { id }, true);
			return response.data;
		},
		getModules: async function (id) {
			const response = await request.send("course", "getModules", { id }, true);
			return response.data;
		},
		getAll: async function() {
			const response = await request.send("course", "getAll", {}, true);
			return response.data;
		},
		listReviews: async function (courseId) {
			const response = await request.send("course", "listReviews", { courseId }, true);
			return response;
		},
		updateInfo: async function (course) {
			let response = await request.send("course", "update", course, true);
			return response.data;
		},
		remove: async function (id) {
			return request.send("course", "delete", { id }, true);
		},
		search: async function(parameters) {
			return request.send("course", "search", parameters, true);
		},
		getSchema: function () {
			return courseSchema;
		},
	}
</script>
